module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-PranceAroundTown-1280.eeb63ad1.jpg";